import { getCompanyInfoAPI } from '../api/my-account.api'

export const getCompanyDetails = async (locale: string) => {
  try {
    return await getCompanyInfoAPI(locale)
  } catch (error) {
    return {}
  }
}
